import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const INFOGRAPHIC_URL =
  'https://aidkbfywmirotpuhmlid.supabase.co/storage/v1/object/public/downloads/justice_infographic.png';

export default function InfographicSection() {
  const [isExpanded, setIsExpanded] = useState(false);
  const navigate = useNavigate();

  const handleDownload = async () => {
    try {
      const response = await fetch(INFOGRAPHIC_URL);
      if (!response.ok) {
        // If the server returns an error status, fall back to opening the image in a new tab
        throw new Error(`Network response was not ok: ${response.status}`);
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'justice_infographic.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Failed to download infographic:', error);
      // As a graceful fallback, open the image in a new tab
      window.open(INFOGRAPHIC_URL, '_blank');
    }
  };

  return (
    <section id="infographic" className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: "'Nanum Myeongjo', serif" }}
          >
            한눈에 보는 사법장악 3법
          </h2>
          <div className="w-24 h-1 bg-red-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-500">
            인포그래픽으로 핵심 내용을 빠르게 파악하세요
          </p>
        </div>

        <div className="relative bg-gray-50 border border-gray-200 rounded-2xl overflow-hidden shadow-lg">
          {/* 이미지 영역 */}
          <div
            className={`relative w-full transition-all duration-500 ease-in-out ${
              isExpanded ? 'max-h-none' : 'max-h-[600px]'
            } overflow-hidden`}
          >
            <img
              src={INFOGRAPHIC_URL}
              alt="사법장악 3법 인포그래픽 - 재판소원법, 대법관 증원법, 법왜곡죄 핵심 정리"
              title="사법정의를 위한 청년 100인 선언 인포그래픽"
              className="w-full h-auto object-contain"
              loading="lazy"
            />
            {/* 그라데이션 오버레이 (접혀있을 때만) */}
            {!isExpanded && (
              <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-gray-50 to-transparent pointer-events-none"></div>
            )}
          </div>

          {/* 펼치기/접기 버튼 */}
          <div className="flex justify-center py-4 bg-gray-50">
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="flex items-center gap-2 px-6 py-2.5 bg-white border border-gray-300 rounded-full text-sm font-semibold text-gray-700 hover:bg-gray-100 hover:border-gray-400 transition-all cursor-pointer whitespace-nowrap shadow-sm"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i
                  className={`ri-arrow-${isExpanded ? 'up' : 'down'}-s-line text-base`}
                ></i>
              </span>
              {isExpanded ? '접기' : '전체 보기'}
            </button>
          </div>
        </div>

        {/* 하단 액션 버튼 */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
          <button
            onClick={handleDownload}
            className="flex items-center gap-2 px-6 py-3 bg-red-600 text-white rounded-full text-sm font-semibold hover:bg-red-700 transition-colors cursor-pointer whitespace-nowrap shadow-lg"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-download-line text-base"></i>
            </span>
            이미지 다운로드
          </button>
          <button
            onClick={() => {
              if (navigator.share) {
                navigator
                  .share({
                    title: '사법장악 3법 인포그래픽',
                    text: '사법장악 독재 3법의 핵심 내용을 한눈에 확인하세요',
                    url: INFOGRAPHIC_URL,
                  })
                  .catch((shareError) => {
                    console.error('Share failed:', shareError);
                    navigator.clipboard.writeText(INFOGRAPHIC_URL);
                  });
              } else {
                navigator.clipboard.writeText(INFOGRAPHIC_URL);
              }
            }}
            className="flex items-center gap-2 px-6 py-3 bg-white border border-gray-300 text-gray-700 rounded-full text-sm font-semibold hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-share-forward-line text-base"></i>
            </span>
            SNS 공유하기
          </button>
          <button
            onClick={() => navigate('/sign')}
            className="flex items-center gap-2 px-6 py-3 bg-gray-900 text-white rounded-full text-sm font-semibold hover:bg-gray-700 transition-colors cursor-pointer whitespace-nowrap shadow-lg"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-pen-nib-line text-base"></i>
            </span>
            지금 바로 서명하기
          </button>
        </div>
      </div>
    </section>
  );
}
